import React from 'react';
import { Wrench, Users, Target, Heart } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

export default function About() {
  const values = [
    { icon: <Users className="w-7 h-7 text-yellow-500" />, title: 'Community First', desc: 'We build for the people of Sri Lanka — connecting neighbours with trusted local talent.' },
    { icon: <Target className="w-7 h-7 text-yellow-500" />, title: 'Trust & Quality', desc: 'Every provider on HIVE is verified. We stand behind the quality of every service booked.' },
    { icon: <Heart className="w-7 h-7 text-yellow-500" />, title: 'Fair for Everyone', desc: 'No hidden fees. Providers keep what they earn. Customers pay fair, transparent prices.' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white dark:from-gray-900 dark:to-gray-800 transition-colors duration-300">
      <Navigation />

      <section className="relative pt-32 md:pt-40 pb-16 overflow-hidden">
        <div className="absolute top-20 -left-20 w-96 h-96 bg-yellow-400/20 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 -right-20 w-96 h-96 bg-yellow-400/10 rounded-full blur-3xl pointer-events-none" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-2xl shadow-lg transform rotate-12 mb-6">
            <Wrench className="w-8 h-8 text-white -rotate-12" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-black text-gray-900 dark:text-white mb-4">About HIVE</h1>
          <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            HIVE is Sri Lanka's home services marketplace — built to make it easy for anyone to find trusted local help, and for skilled people to earn from what they love doing.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white/60 dark:bg-gray-800/60 backdrop-blur-xl rounded-3xl border border-gray-200/50 dark:border-gray-700/50 shadow-xl hover:shadow-2xl hover:scale-[1.01] transition-all duration-300 p-8 md:p-12 text-center">
            <h2 className="text-3xl font-black text-gray-900 dark:text-white mb-4">Our Mission</h2>
            <p className="text-gray-600 dark:text-gray-400 text-lg max-w-2xl mx-auto">
              To create economic opportunity for every skilled person in Sri Lanka — while making it effortless for homes and businesses to get the help they need.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 pb-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-black text-gray-900 dark:text-white text-center mb-10">What We Stand For</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {values.map((v, i) => (
              <div key={i} className="bg-white/60 dark:bg-gray-800/60 backdrop-blur-xl rounded-2xl border border-gray-200/50 dark:border-gray-700/50 shadow-lg p-6 hover:shadow-2xl hover:scale-[1.03] hover:border-yellow-400/50 transition-all duration-300 group">
                <div className="w-14 h-14 bg-yellow-50 dark:bg-yellow-900/20 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  {v.icon}
                </div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">{v.title}</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}